import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PlayCanvas } from "@/components/field/PlayCanvas";
import { phasesSorted, phaseNoteFor, playerById } from "@/lib/playEngine";

export function WalkThrough({ play, team, pb, posId, canvasClass }) {
  const phases = phasesSorted(play);
  const [idx, setIdx] = useState(0);
  const p = posId && playerById(play, posId);
  const ph = phases[idx];
  const next = () => { if (idx < phases.length - 1) { pb.playRange(phases[idx].time, phases[idx + 1].time); setIdx(idx + 1); } };
  const back = () => { if (idx > 0) { pb.seek(phases[idx - 1].time); setIdx(idx - 1); } };
  if (!phases.length) return <p className="card p-5 text-slate-400" data-testid="walk-no-phases">This play has no phases yet. A coach can add them in the editor's Phases tab.</p>;

  return (
    <div className="space-y-3" data-testid="walkthrough-mode">
      <div className="rounded-2xl overflow-hidden border border-[#1F3358]">
        <PlayCanvas play={play} team={team} t={pb.t} highlightId={posId} className={canvasClass} />
      </div>
      <div className="card p-4" data-testid="walk-instruction">
        <p className="label">Step {idx + 1} of {phases.length}</p>
        <p className="font-display text-3xl font-extrabold uppercase text-[#FF8A1F]" data-testid="walk-phase-name">{ph.name}</p>
        <p className="text-lg mt-1" data-testid="walk-phase-note">{p ? <><b>{p.label}:</b> {phaseNoteFor(play, p, idx)}</> : "Pick a position to see that player's instruction."}</p>
      </div>
      <div className="grid grid-cols-2 gap-3 sticky bottom-20 md:bottom-3 z-30">
        <button className="btn btn-ghost min-h-[72px] text-xl font-display uppercase" onClick={back} disabled={idx === 0} data-testid="btn-walkthrough-back"><ChevronLeft size={28} />Back</button>
        <button className="btn btn-primary min-h-[72px] text-xl font-display uppercase" onClick={next} disabled={idx >= phases.length - 1} data-testid="btn-walkthrough-next">Next<ChevronRight size={28} /></button>
      </div>
    </div>
  );
}
